import { ConditionName, ICaptchaProps } from "interfaces";
import IMAGES from "../../../../../images/importImages";
import { conditions } from "helpers";

const Captcha = (props: ICaptchaProps): JSX.Element => {
    return (
        <>
            {
                props.captcha && (
                    <div className={`${conditions(ConditionName.isTouchScreenPortrait) ? "pl-mt-0" : "pl-mt-8"}`}>
                        <p className="pl-text-[14px] pl-font-normal pl-text-z-gray-700 dark:pl-text-dark-5">کلمات تصویر را وارد کنید.</p>
                        <div className={`pl-flex pl-gap-4 ${conditions(ConditionName.isTouchScreenPortrait) ? "pl-flex-col" : "pl-items-center"}`}>
                            <input autoFocus className="pl-bg-transparent pl-w-full pl-outline-none pl-rounded-[10px] pl-border-[1.5px] pl-border-main-light pl-px-4 pl-py-1" onChange={(event:any) => props.setCaptchaValue({...props.captcha, value: event.target.value})}/>
                            <div className={`${conditions(ConditionName.isTouchScreenPortrait) ? "pl-justify-start" : "pl-items-center"} pl-flex  pl-gap-2 pl-items-center`}>
                                <img
                                    src={
                                        (props.captcha.provider === "LOCAL-CAPTCHA") ?
                                            `data:image/png;base64, ${props.captcha.image}` :
                                            `${props.captcha.image}`
                                    }
                                    alt={props.captcha.provider}
                                    className='pl-h-[50px]'
                                    style={{ backgroundColor: "white" }}
                                />
                                <img src={IMAGES.refresh} alt="refresh" width={24} height={24} className='pl-cursor-pointer' onClick={props.getNewCaptcha} />
                            </div>
                        </div>
                    </div>
                )
            }
            {props.error && <p>{props.error}</p>}
        </>
    )
}

export default Captcha